var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.getShowAppBar)?_c('dashboard-core-app-bar',{ref:"appBar",on:{"selectLanguageEvent":_vm.selectLanguage}}):_vm._e(),_c('dashboard-core-drawer',{ref:"navDrawer",attrs:{"parentComponent":_vm.$refs}}),_c('dashboard-core-view',{ref:"component",attrs:{"parentComponent":_vm.$refs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }